import type { DocMigration } from "../docMigration";
import { forEachFormula } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_20: DocMigration = {
  maxSchemaVersion: "0.0.20",
  apply(json: any) {
    forEachFormula(json, (form) => {
      (form as any).formula = form.formula.replace("exteriorWallThickness", "3.5");
    });

    delete json.wallConfig;

    return json;
  },
};

export default migration_0_0_20;
